import type { UserRetrieveResponse } from '@fireflyhealth/api'
import { useSelector } from 'react-redux'
import { AssigneeGroupOption, deprecatedGroupOption, getAssignableUserGroups } from './userGroups'

export function useGroupOptions(
  value: number | null,
  canAssignToPatient: boolean,
  patient?: UserRetrieveResponse | null,
  careTeam?: number[],
  disabled?: boolean,
) {
  const providers = useSelector(state => state.providers)

  const assigneeGroups = useSelector(state => state.assigneeGroups)
  const careTeamDetails = careTeam ?? []

  const groupedOptions = getAssignableUserGroups(
    providers,
    canAssignToPatient,
    careTeamDetails,
    patient,
    assigneeGroups,
  )
  const flatOptions: AssigneeGroupOption[] = []
  groupedOptions.map(category => flatOptions.push(...category.options))

  // A work unit already assigned to a deprecated group must keep showing that group's name, even
  // though the group is no longer assignable. Resolve the current value from the full list and add
  // it back as a disabled option, so the select renders the name instead of an empty owner.
  const retiredSelection =
    value != null && !flatOptions.some(option => option.value == value)
      ? assigneeGroups?.find(group => group.id == value)
      : undefined
  if (retiredSelection) {
    const retiredOption = deprecatedGroupOption(retiredSelection)
    flatOptions.push(retiredOption)
    const groupsCategory = groupedOptions.find(category => category.label === 'GROUPS')
    if (groupsCategory) {
      groupsCategory.options.push(retiredOption)
    } else {
      groupedOptions.push({ label: 'GROUPS', options: [retiredOption] })
    }
  }

  const selectedCaseOwnerGroupOption = flatOptions.find(option => option.value == value)

  return { selectedCaseOwnerGroupOption, flatOptions, groupedOptions, disabled }
}
